
export { IPageController } from "./page-controller";
export { IPageObjectTreeService } from "./page-object-tree";
export { PageCacheKey } from "./page-object-tree";

/********匿名用户相关类型********/
export { AnonymousPageController } from "./anonymous/anonymous-page.controller";
export { IAnonymousUserLoginService } from "./anonymous/anonymous-user-login.service";
export { IAnonymousPageObjectTreeService } from "./anonymous/anonymous-page-object-tree";

/********登录用户相关类型********/
export { AuthorizedPageController } from "./authorized/authorized-page.controller";
export { IAuthorizedPageObjectTreeService } from "./authorized/authorized-page-object-tree";

export { IResponseUser, IAnonymousResponseUser } from "./response-user";

export { ILoginCacheKey } from "./login-cache-key";